/**
 * 管理后台登录：邮箱 + 密码 + 可选的两步验证动态码，一次提交。
 *
 * 背景：两步验证不是强制的。运营账号没开启就只填邮箱和密码；开启了，后端 /admin/auth/login 会要求动态码，
 *   缺少时返回 totp_required。
 * 设计意图：三项放在同一个表单里，不像控制台那样分两步：运营人数少，分步只会多一次往返。动态码框不设必填，
 *   由后端判断这个账号是否需要。
 * 关键约束：登录失败不区分「账号不存在」「不是运营」「密码错」，提示统一来自后端错误码。
 */
import { useState } from 'react'
import { adminApi } from '@ap/api-client/admin'
import { A } from '@ap/i18n/admin'
import { C, errorText } from '@ap/i18n/common'
import { useI18n } from '@ap/i18n'
import { Button, Card, Field, Form, Input, LocaleSelect, Notice } from '@ap/ui'
import { useAdmin } from '../session.tsx'

export function Login() {
  const { t, locale } = useI18n()
  const { setAccount } = useAdmin()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const submit = async () => {
    setBusy(true)
    setError('')
    try {
      const r = await adminApi.login(email.trim(), password, code.trim())
      setAccount(r.account)
    } catch (e) {
      setError(errorText(e, locale))
      setCode('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth">
      <div className="ap-auth__box">
        <div className="ap-auth__brand">
          <div className="ap-brand" style={{ padding: 0 }}>
            Asterove <small>{t(A.nav.title)}</small>
          </div>
          <LocaleSelect />
        </div>
        <Card className="ap-auth__card">
          <Form onSubmit={submit}>
            <div>
              <h1>{t(A.login.title)}</h1>
              <p className="lead">{t(A.login.lead)}</p>
            </div>
            {error && <Notice tone="danger">{error}</Notice>}
            <Field label={t(C.email)}>
              <Input type="email" autoComplete="username" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
            </Field>
            <Field label={t(C.password)}>
              <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </Field>
            <Field label={t(C.totpCode)} hint={t(A.login.codeHint)}>
              <Input
                mono
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={12}
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </Field>
            <Button type="submit" variant="primary" block loading={busy}>
              {t(A.login.submit)}
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  )
}
